import { Box } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React from "react";
import {
  CustomErrorOverlay,
  CustomNoRowsOverlay,
  SkeletonLoadingOverlay,
} from "../../admin/admin.overlays";
import "./BaseDataGrid.css";

/**
 * @see [Documentation](../../../../Wiki/Documentations/FrontEnd/Components/BaseDataGrid.md)
 */
export default function BaseDataGrid({
  rows,
  loading,
  columns,
  error,
  width,
  height,
  errorMessage,
  useContainer = true,
  EmptyRowMessage,
  containerStyles,
  density = "compact",
  // autoHeight = true,
  ...rest
}) {
  function CustomErrorMessageOverlay() {
    return <CustomErrorOverlay errorMessage={errorMessage} />;
  }
  columns?.forEach((col) => {
    col && typeof col === "object" ? (col.description = col?.headerName) : null;
  });

  function CustomNoRowsOverlayMsg() {
    return <CustomNoRowsOverlay msg={EmptyRowMessage} />;
  }

  const dataGridProps = {
    disableRowSelectionOnClick: !!rest?.disableRowSelectionOnClick,
    rows: rows || [],
    // autoHeight,
    className: loading ? "loadingDataGrid" : "",
    components: {
      NoRowsOverlay: errorMessage
        ? CustomErrorMessageOverlay
        : CustomNoRowsOverlayMsg,
      LoadingOverlay: SkeletonLoadingOverlay,
      ErrorOverlay: CustomErrorOverlay,
    },
    initialState: { },
    border: 0,
    loading,
    columns: columns || [],
    headerHeight: 80,
    rowHeight: 44,
    disableSelectionOnClick: !!rest?.disableSelectionOnClick,
    pagination: false,
    cellClassName: "dataCells",
    error: error || undefined,
    density: density,
    ...rest,
  };

  return (
    <>
      {useContainer ? (
        <Box
          display={"block"}
          flexGrow={1}
          height={height || "90%"}
          width={width || "100%"}
          overflow={"auto"}
          sx={{
            "& .super-app-theme--header": {
              backgroundColor: rest?.headerColor,
            },
          }}
          {...containerStyles}>
          <DataGridPro {...dataGridProps} />
        </Box>
      ) : (
        <DataGridPro 
          {...dataGridProps} 
        />
      )}
    </>
  );
}
